import { Injectable } from '@angular/core';

@Injectable()
export class CertificadoService {

  webPkiLicense: string = 'Ah8AKi5naXNzLmNvbS5iciwqLnNlZmF6LmNlLmdvdi5ickMAaXA0OjEwLjAuMC4wLzgsaXA0OjEyNy4wLjAuMC84LGlwNDoxNzIuMTYuMC4wLzEyLGlwNDoxOTIuMTY4LjAuMC8xNgMAUHJvAAAAATnab+02auTHVJmNUJAc1CdIarkMW+5FyzLb5pfXznN1w51JuOdNYyBJyjzdkqRSYdz+oKFH6or1iiQBIbYwy29RZh7yU3WRd+O7hOxq2v2elieXkiF6xIMM7D9K/3421gHav1TAB4buvXARQRoDJ/g7YykR/AdQHcRUKlw5TDBq+UGGzVbwA6uL5ZDhzkgb0eBSMB76OVC4it16NyX81y4kEhBLKBupTc7HbmJ5XfA/tq2HFSFTp7nykKdjVffjUDXHijdcEr5/HvBTRoQU18SyjFbYPZMdrCZCYJ4uAUEPg7iu0LKSCTugoaNxqxFCfFxxdLYjK0dBWVsTl8kmr4E='; 
}